import { createBrowserRouter } from "react-router-dom";

import { Home, Error, Policy, Inquiry } from "pages";

const routes = createBrowserRouter([
  {
    path: "/",
    errorElement: <Error />,
    children: [
      { index: true, element: <Home /> },
      { path: "block", children: [{ index: true, element: <Policy /> }] },
      { path: "voc", children: [{ index: true, element: <Inquiry /> }] },
    ],
  },
]);

export default routes;
